/* Component: AsDropdown
 * Author:    AM
 * Date:      16/03/2021
 *      AsDropdown is a custom select box with extended functionality.
 *      Tickboxes can be enabled by passing the onTick(elementId) function.
 *      An Apply button can be enabled by passing the onApply(event) function.
 *      onOpen() and onClose() get fired when the tongue is expanded or collapsed, respectively.
 */
import React, { forwardRef } from 'react';
import { AsDropdownProvider } from './AsDropdownContext';
import AsDropdownInput from './AsDropdownInput';
import PropTypes from 'prop-types';

export const asDropdownTickBoxTextFormatter = (array, array2) => {
    switch (array.length) {
        case array2.length:
            return 'All';
        case 0:
            return 'None';
        case 1:
            return array[0].name;
        default:
            return `Multiple (${array.length})`;
    }
};

const AsDropdown = forwardRef(
    (
        {
            activeValues = [],
            disabled = false,
            disabledStyle,
            disabledValues = [],
            height = 'max-content',
            id,
            inputStyle,
            labelStyle,
            tongueStyle,
            containerStyle,
            name,
            onApply,
            onChange,
            onCheck,
            onClose,
            onOpen,
            onTick,
            style,
            title,
            value,
            values,
            width,
            transformChevron = false,
            placeholder = 'Select...',
            ...props
        },
        ref
    ) => {
        return (
            <AsDropdownProvider>
                <AsDropdownInput
                    ref={ref}
                    activeValues={activeValues}
                    disabled={disabled}
                    disabledStyle={disabledStyle}
                    disabledValues={disabledValues}
                    height={height}
                    id={id || `as-dropdown-${name || title}`}
                    inputStyle={inputStyle}
                    labelStyle={labelStyle}
                    tongueStyle={tongueStyle}
                    containerStyle={containerStyle}
                    name={name}
                    onApply={onApply}
                    onChange={onChange}
                    onCheck={onCheck}
                    onClose={onClose}
                    onOpen={onOpen}
                    onTick={onTick}
                    style={style}
                    title={title}
                    value={value}
                    values={values}
                    width={width}
                    transformChevron={transformChevron}
                    placeholder={placeholder}
                    {...props}
                />
            </AsDropdownProvider>
        );
    }
);

AsDropdown.displayName = 'AsDropdown';

AsDropdown.defaultProps = {
    placeholder: 'Select...',
    transformChevron: false,
    height: 'max-content',
    disabled: false,
    activeValues: [],
    disabledValues: []
};

AsDropdown.propTypes = {
    activeValue: PropTypes.object,
    activeValues: PropTypes.array,
    disabled: PropTypes.bool,
    disabledValues: PropTypes.array,
    id: PropTypes.string,
    name: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    initialValue: PropTypes.any,
    style: PropTypes.object,
    containerStyle: PropTypes.object,
    inputStyle: PropTypes.object,
    labelStyle: PropTypes.object,
    tongueStyle: PropTypes.object,
    textStyle: PropTypes.object,
    onApply: PropTypes.func,
    onChange: PropTypes.func,
    onCheck: PropTypes.func,
    onClose: PropTypes.func,
    onOpen: PropTypes.func,
    onTick: PropTypes.func,
    optionStyle: PropTypes.object,
    placeholder: PropTypes.string,
    title: PropTypes.string,
    value: PropTypes.any,
    values: PropTypes.array,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default AsDropdown;
